import {createSlice} from "@reduxjs/toolkit";

const initialdatasState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  activeCount: 0,
  entities: null,
  dataForEdit: undefined,
  dataForView: null,
  lastError: null,
  tasks: null,
  meta: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const AccountSlice = createSlice({
  name: "accounts",
  initialState: initialdatasState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getdataById
    dataFetched: (state, action) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.dataForView = action.payload;
      state.error = null;
    },
    tasksFetched: (state, action) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.tasks = action.payload;
      state.error = null;
    },
    accounts: (state, action) => {
      state.listLoading = false;
      state.entities = action.payload;
      state.error = null;
    },
    disabledLoading: (state, action) => {
      state.listLoading = false;
      state.actionsLoading = false;
    },
    clearError: (state, action) => {
      state.error = null;
    },
    accountsMeta: (state, action) => {
      state.listLoading = false;
      state.meta = action.payload;
      state.totalCount = action.payload.total_items;
      state.error = null;
    },
    // finddatas
    datasFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    allIncidentCount: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.totalCount = action.payload;
    },
    activeIncidentCount: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.activeCount = action.payload;
    },
    // createdata
    dataCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload);
    },
    // updatedata
    dataUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.id === action.payload.data.id) {
          return action.payload.data;
        }
        return entity;
      });
    },
    // deletedata
    dataDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    // deletedatas
    datasDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      );
    },
    // datasUpdateState
    datasStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map(entity => {
        if (ids.findIndex(id => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    }
  }
});
